import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "text-left flex flex-col text-textPrimary" }
const _hoisted_2 = { class: "flex items-center gap-3 mb-1" }
const _hoisted_3 = { class: "text-[10px] text-gray-400 uppercase font-bold leading-none" }
const _hoisted_4 = { class: "text-sm font-medium text-gray-500 leading-tight" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 text-gray-400 mx-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = { class: "text-xl font-bold text-gray-700" }
const _hoisted_8 = { class: "font-bold text-2xl text-textPrimary leading-tight" }
const _hoisted_9 = {
  key: 0,
  class: "text-base text-gray-500"
}
const _hoisted_10 = {
  key: 1,
  class: "flex flex-wrap items-center mt-1 text-sm text-gray-500"
}
const _hoisted_11 = {
  key: 0,
  class: "mx-1"
}

import { computed } from 'vue'
import { ShiftDetails } from '@/Network/Types/Responses/StationResponses'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalHeader',
  props: {
    stationDetails: {},
    resourceType: {},
    resourceId: {},
    headerTitle: {},
    breadcrumbs: {}
  },
  setup(__props: any) {

const props = __props;



const isStation = computed(() => !!props.stationDetails)

const typeLabel = computed(() => {
  if (isStation.value) return 'Estação'
  return props.resourceType || 'Recurso'
})

const mainId = computed(() => {
  if (isStation.value) return props.stationDetails?.id
  return props.resourceId
})

const secondaryId = computed(() => {
  if (isStation.value) return props.stationDetails?.doctorStation?.id
  return null
})

const title = computed(() => {
  if (props.headerTitle) return props.headerTitle
  return 'Detalhes do Plantão'
})

const breadcrumbsText = computed(() => {
  if (isStation.value && props.stationDetails) {
    const s = props.stationDetails
    return `${s.schedule?.healthUnit?.company?.name || 'Companhia'} > ${s.schedule?.healthUnit?.name || 'Unidade de Saúde'} > ${s.schedule?.name || 'Escala'} > ${s.position?.name || 'Posição não definida'}`
  }
  return null
})

const breadcrumbsList = computed(() => props.breadcrumbs || [])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (mainId.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["flex items-center bg-gray-50 rounded-lg border border-gray-100 p-1 shadow-sm", secondaryId.value ? 'pr-3' : 'px-3'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-col", { 'px-2 border-r border-gray-200 mr-2': secondaryId.value }])
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(typeLabel.value), 1),
              _createElementVNode("span", _hoisted_4, "#" + _toDisplayString(mainId.value), 1)
            ], 2),
            (secondaryId.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, "#" + _toDisplayString(secondaryId.value), 1)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("strong", _hoisted_8, _toDisplayString(title.value), 1)
    ]),
    (breadcrumbsText.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(breadcrumbsText.value), 1))
      : (breadcrumbsList.value && breadcrumbsList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbsList.value, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("span", null, _toDisplayString(item), 1),
                (index < breadcrumbsList.value.length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " > "))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})